import React, { useCallback, useContext } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { AGENDAITEM_PROPERTY, ProtocolTagKeys } from "src/stores/assemblies/AgendaItemStore";
import styles from "./ProtocolText.module.css";
import { RootStoreContext } from "src/stores/RootStore";
import { runInAction } from "mobx";

const ProtocolTextBase = observer(() => {
    const { agendaitemStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const onClickProtocolTag = useCallback(
        (translationKey: string) => (e: React.MouseEvent) => {
            const textToAdd = t(translationKey);

            runInAction(() => {
                if (agendaitemStore.currentAgendaItem) {
                    const cur = agendaitemStore.currentAgendaItem.protocoltext || "";
                    agendaitemStore.currentAgendaItem.protocoltext = cur ? `${cur} ${textToAdd} ` : `${textToAdd} `;
                }
            });

            document.getElementById("agendaProtocolText")?.focus();
        },
        [agendaitemStore, t]
    );

    const onBlurProtocolText = useCallback(() => {
        agendaitemStore.saveProtocolText();
    }, [agendaitemStore]);

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            agendaitemStore.updateAgendaItem(AGENDAITEM_PROPERTY.PROTOCOLTEXT, e.target.value);
            agendaitemStore.setAgendaItemsHaveChanged();
        },
        [agendaitemStore]
    );

    return (
        <div className={styles.ProtocolContainer}>
            <div
                className={
                    agendaitemStore.isAgendaItemLocked
                        ? styles.ProtocolTagsContainerLocked
                        : styles.ProtocolTagsContainer
                }
            >
                {!agendaitemStore.isAgendaItemLocked && (
                    <div className={styles.ProtocolTags}>
                        {Object.values(ProtocolTagKeys).map((key) => (
                            <div key={key} className={styles.Tags} onClick={onClickProtocolTag(key)}>
                                {t(key)} <UI.Icon icon={UI.SVGIcon.Add} size={12} className={styles.AddIconTags} />
                            </div>
                        ))}
                    </div>
                )}

                <textarea
                    id="agendaProtocolText"
                    className={styles.AgendaItemProtocoltext}
                    value={agendaitemStore.currentAgendaItem?.protocoltext || ""}
                    onChange={onChange}
                    onBlur={onBlurProtocolText}
                    placeholder={
                        agendaitemStore.isAgendaItemLocked ? "" : t("screens.assemblies.agenda.protocol_placeholder")
                    }
                    disabled={agendaitemStore.isAgendaItemLocked}
                />
            </div>
        </div>
    );
});

export const ProtocolText = ProtocolTextBase;
